import {useField} from 'formik';

import {FormControlLabel, RadioGroup} from '@mui/material';

import UiRadio from './ui/Radio';

interface Props {
  name: string;
  options: {label: string; value: string}[];
}

export const FormRadio = ({name, options, ...otherProps}: Props) => {
  const [field] = useField(name);

  const handleChange = (event: any) => {
    const {value} = event.target;
    field.onChange(name)(value);
  };

  const configRadioGroup = {
    ...field,
    ...otherProps,
    onChange: handleChange,
  };

  return (
    <RadioGroup {...configRadioGroup}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<UiRadio data-testid={name + '-' + option.value} />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
};
